// extracted by mini-css-extract-plugin
module.exports = {"gotoPage":"gotoPage_gotoPage__m1JPT"};